@if (loaderIcon | async) {
<app-loader></app-loader>
}
<!-- Developed by Sheldon 11/17/2025-->
<div class="container-fluid ">
    <div class="row g-3" *ngIf="!disContactPerson && !disWebInquirySettings">
        <div class="col-lg-6 d-flex flex-column gap-3">
            <div class="card shadow p-3 ">
                <div class="d-flex justify-content-between align-items-center mb-2">
                    <h6 class="fw-bold mb-0">Personal Account Information</h6>
                    <div>
                        <ejs-tooltip id='tooltipbtnNewCard' target="#targetNewCard" position='LeftCenter'
                            (beforeOpen)="onBeforeOpen($event)">
                            <button class="btn btn-outline-AS" [userPermissionHandler]="editPermissionHandlerData"
                                (click)="UpdateVendor()">
                                Edit Info <i class="fa fa-edit"></i>
                            </button>
                        </ejs-tooltip>
                    </div>
                </div>
                <div class="d-flex align-items-center mb-3">

                    @if(vendorInfo?.VendorProfile == "")
                    {
                    <div class="profile-placeholder me-3">
                        <img src="./assets/images/NoPhoto-Dashboard.svg">
                    </div>
                    }@else{

                    <div class="profile-placeholder-image me-3">
                        <img [src]="vendorInfo?.VendorProfile +`?timestamp=${this.timestamp}`">
                    </div>
                    }
                    <div>
                        <h5 class="mb-1">{{vendorInfo?.VendorName}}</h5>
                        <span class="text-muted">ID : {{vendorInfo?.MarketVendorId}}</span>
                    </div>

                </div>

                <div class="vendor_detail row">
                    <div class="col-sm-6">
                        <ul class="list-unstyled">
                            <li>
                                <label i18n>Vendor Type</label>
                                <p>{{vendorInfo?.VendorType}}</p>
                            </li>

                            <li class="mt-2">
                                <label>First Name</label>
                                <p>{{vendorInfo?.FirstName}}</p>
                            </li>

                            @if (VendorGeneralSetting?.VendorNameFormat?.includes('Middle Name')) {
                            <li class="mt-2">
                                <label>Middle Name</label>
                                <p>{{vendorInfo?.MiddleName}}</p>
                            </li>
                            }

                            @if (VendorGeneralSetting?.VendorNameFormat?.includes('Last Name')) {
                            <li class="mt-2">
                                <label>Last Name</label>
                                <p>{{vendorInfo?.LastName}}</p>
                            </li>
                            }

                            <li class="mt-2">
                                <label i18n>Address</label>
                                <p>{{vendorInfo?.Address}}</p>
                            </li>
                            <li class="mt-2">
                                <label i18n>City</label>
                                <p>{{vendorInfo?.City}}</p>
                            </li>
                            <li class="mt-2">
                                <label i18n>State</label>
                                <p>{{vendorInfo?.State}}</p>
                            </li>
                            <li class="mt-2">
                                <label i18n>Zip/Postal Code</label>
                                <p>{{vendorInfo?.ZipCode | zipCode}}</p>
                            </li>
                            <li class="mt-2">
                                <label i18n>Country</label>
                                <p>{{vendorInfo?.Country}}</p>
                            </li>

                        </ul>
                    </div>

                    <div class="col-sm-6">
                        <ul class="list-unstyled">

                            <li class="mt-2">
                                <label i18n>Driver License #</label>
                                <p>{{vendorInfo?.DLno}}</p>
                            </li>
                            <li class="mt-2">
                                <label i18n>DL Expiry Date</label>
                                <p>{{vendorInfo?.DLExpiryDate | date:'MM/dd/YYYY'}}</p>
                            </li>

                            <li class="mt-2">
                                <label i18n>Work Phone</label>
                                <p>{{vendorInfo?.WorkPhone | phoneFormat}}</p>
                            </li>
                            <li class="mt-2">
                                <label i18n>Cell Phone</label>
                                <p>{{vendorInfo?.CellPhone | phoneFormat}}</p>
                            </li>
                            <li class="mt-2">
                                <label i18n>Telephone</label>
                                <p>{{vendorInfo?.TelePhone | phoneFormat}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="vendor_detail row mt-0">
                    <div class="col-sm-12">
                        <ul class="list-unstyled">
                            <li>
                                <label i18n>Email</label>
                                <p>{{vendorInfo?.Email}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="card shadow p-3 ">
                <div class="mt-2">
                    <div class="row g-4">
                        <div class="col-md-6">
                            <label class="form-label">Facebook ID</label>
                            <div class="input-group">
                                <span class="input-group-text text-white" style="background-color: #106FBE">
                                    <i class="fab fa-facebook-f text-white"></i>
                                </span>
                                <input type="text" class="form-control" [ngModel]="vendorInfo?.FacebookID" disabled>
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label">LinkedIn ID</label>
                            <div class="input-group">
                                <span class="input-group-text bg-primary text-white" style="background-color: #0082CA;">
                                    <i class="fab fa-linkedin-in text-white"></i>
                                </span>
                                <input type="text" class="form-control" [ngModel]="vendorInfo?.LinkedInID" disabled>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-lg-6 d-flex flex-column gap-3">

            <div class="card shadow p-3">
                <h6 class="fw-bold mb-3">Vendor Products</h6>
                <ejs-grid [dataSource]="vendorProducts" height="150" [allowPaging]="false">
                    <e-columns>
                        <e-column field="product" headerText="Product" width="150"></e-column>
                        <e-column field="category" headerText="Category" width="150"></e-column>
                        <e-column field="primary" headerText="Primary" width="100">
                            <ng-template #template let-data>
                                @if(data.primary == true)
                                {
                                <i class="fa fa-check" style="color: green;" aria-hidden="true"></i>
                                }
                            </ng-template>
                        </e-column>
                    </e-columns>
                </ejs-grid>
            </div>
            <div class="card shadow p-3 h-100">
                <div class="row">
                    <div class="col-12 d-flex flex-wrap gap-2">
                        <button class="btn btn-outline-AS" hidden>Licenses</button>
                        <button class="btn btn-outline-AS" (click)="contactPerson()">Contact Person</button>
                        <ejs-tooltip id='tooltipbtnACH' target="#venACHBtn" position='LeftCenter'
                            (beforeOpen)="onBeforeOpen($event)">
                            <button class="btn btn-outline-AS" id="venACHBtn" data-bs-toggle="modal"
                                [disabled]="!enableACH" [userPermissionHandler]="viewPermissionHandlerData"
                                data-bs-target="#modalACH" (click)="clickACHBtn()" style="display:none">ACH</button>
                        </ejs-tooltip>
                        <button class="btn btn-outline-AS" (click)="wiSettings()">Web Inquiry</button>
                        <button class="btn btn-outline-AS" (click)="openChangeVendorIdModal()">Change Vendor ID</button>
                    </div>
                </div>
            </div>

        </div>
    </div>

    <div class="row" *ngIf="disContactPerson">
        <div class="col-12 text-start my-2">
            <app-ops-contact-person [vendorId]="vendorId" (close)="onCloseContactPerson()"></app-ops-contact-person>
        </div>
    </div>
    <div class="row" *ngIf="disWebInquirySettings">
        <div class="col-12 text-start my-2">
            <app-ops-web-inquiry-settings [vendorId]="vendorId"
                (close)="onCloseWISettings()"></app-ops-web-inquiry-settings>
        </div>
    </div>
</div>
<div class="modal fade" id="modalACH" tabindex="-1" aria-labelledby="modalACHLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalACHLabel">ACH</h1>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="border p-3 rounded shadow-sm mb-2">
                    <div class="row g-2 align-items-center">
                        <div class="col-md-6 col-lg-4">
                            <p class="mb-1"><strong>{{'Vendor ID : ' |
                                    wordReplace}}</strong>{{vendorInfo?.MarketVendorId}}</p>
                            <p class="mb-1"><strong>Name :</strong> {{vendorInfo?.VendorName}}</p>
                        </div>
                        <div class="col-md-6 col-lg-4">
                            <p class="mb-1"><strong>Phone :</strong> {{vendorInfo?.Telephone}}</p>
                            <p class="mb-1"><strong>Email :</strong> {{vendorInfo?.Email}}</p>
                        </div>
                    </div>
                </div>
                <h6>Vendor ACH Details</h6>
                <div class="row">
                    <div class="col-md-6 text-start mt-3">
                        <label class="mb-0" for="txtRoutingNum">Routing Number</label>
                        <input type="text" id="txtRoutingNum" class="form-control" [(ngModel)]="vendorRoutingNo">
                    </div>
                    <div class="col-md-6 text-start mt-3">
                        <label class="mb-0" for="txtAcNum">Account Number</label>
                        <input type="text" id="txtAcNum" class="form-control" [(ngModel)]="vendorAccountNo">
                    </div>
                    <div class="col-md-6 text-start mt-3">
                        <label class="mb-0" for="txtAcHolderName">Account Holder Name</label>
                        <input type="text" id="txtAcHolderName" class="form-control"
                            [(ngModel)]="vendorAccountHolderName">
                    </div>
                    <div class="col-md-6 text-start mt-3">
                        <label class="mb-0" for="txtChecking">Checking</label>
                        <select class="form-select" id="txtChecking" [(ngModel)]="vendorAccountType">
                            <option value="null" selected>Select</option>
                            @for (type of accounTypesACH; track type.Id) {
                            <option [value]="type.Id">{{ type.Name }}</option>
                            }
                        </select>
                    </div>
                    @if (this.vendorInfo?.AchACHAccountToken) {
                    <div class="col-md-6 text-start mt-3">
                        <div class="form-check me-2">
                            <input type="checkbox" id="chkEnableAutoPayment" class="form-check-input"
                                [(ngModel)]="vendorEnableACHAutoPay">
                            <label for="chkEnableAutoPayment" class="form-check-label">Enable Autopayment</label>
                        </div>
                    </div>
                    <div class="col-md-6 text-start mt-3">
                        <label class="mb-0" for="txtAcToken">Token</label>
                        <input type="text" id="txtAcToken" class="form-control"
                            [ngModel]="this.vendorInfo?.AchACHAccountToken" readonly>
                    </div>
                    }
                </div>
            </div>
            <div class="modal-footer">
                @if (!this.vendorInfo?.AchACHAccountToken) {
                <ejs-tooltip id='tooltipbtnACH' target="#venACHCreateToken" position='LeftCenter'
                    (beforeOpen)="onBeforeOpen($event)">
                    <button type="button" class="btn btnAS me-1" id="venACHCreateToken"
                        [userPermissionHandler]="createPermissionHandlerData" [disabled]="disableSaveAch()"
                        (click)="createVendorACHToken()">Create Token</button>
                </ejs-tooltip>
                }
                @if (this.vendorInfo?.AchACHAccountToken) {
                <button type="button" class="btn btnAS me-1" [disabled]="!this.vendorInfo?.AchACHAccountToken"
                    (click)="verifyACHAlias()">Lookup Token</button>
                <ejs-tooltip id='tooltipbtnACH' target="#venACHLookupToken" position='LeftCenter'
                    (beforeOpen)="onBeforeOpen($event)">
                    <button type="button" class="btn btnAS me-1" id="venACHLookupToken"
                        [userPermissionHandler]="deletePermissionHandlerData"
                        [disabled]="!this.vendorInfo?.AchACHAccountToken" (click)="deleteACHAlias()">Delete
                        Token</button>
                </ejs-tooltip>
                }
                <ejs-tooltip id='tooltipbtnACH' target="#venACHDeleteToken" position='LeftCenter'
                    (beforeOpen)="onBeforeOpen($event)">
                    <button type="button" class="btn btnAS me-1" id="venACHDeleteToken"
                        [userPermissionHandler]="createPermissionHandlerData" [disabled]="disableSaveAch()"
                        (click)="saveACHVendorDetails()">Save</button>
                </ejs-tooltip>

                <button type="button" class="btn btn-orange" data-bs-dismiss="modal">Cancel</button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="modalChangeVendorId" #modalChangeVendorId tabindex="-1"
    aria-labelledby="modalChangeVendorIdLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h1 class="modal-title fs-5" id="modalChangeVendorIdLabel">Change Vendor ID</h1>
                <button type="button" class="btn-close" (click)="closeModalById('modalChangeVendorId')"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body">
                <div class="mb-3">
                    <label class="form-label">Current Vendor ID</label>
                    <input type="text" class="form-control" [ngModel]="vendorInfo?.MarketVendorId" readonly>
                </div>
                <div class="mb-3">
                    <label class="form-label">New Vendor ID</label>
                    <input type="text" class="form-control" [(ngModel)]="newVendorId" placeholder="Enter new Vendor ID"
                        (input)="allowOnlyAlphaNumericVendorId($event)" maxlength="9">
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btnAS me-1" (click)="saveChangeVendorId()">Save</button>
                <button type="button" class="btn btn-orange"
                    (click)="closeModalById('modalChangeVendorId')">Cancel</button>
            </div>
        </div>
    </div>
</div>